import { Trans } from 'react-i18next';
import { BookingParticipant } from '../../shared/types';

export type Participant = BookingParticipant;
export type GuestChipProps = {
  participant: BookingParticipant;
  isSelected?: boolean;
  onClick: () => void;
};

type Props = {
  participants: BookingParticipant[];
  selectedParticipants: string[];
  onParticipantsChange: (p: string[]) => void;
  renderGuestChip: (p: GuestChipProps) => JSX.Element;
  additionalParticipantSlot?: JSX.Element;
};

export function BookitoParticipantsPicker({
  participants,
  selectedParticipants,
  onParticipantsChange,
  renderGuestChip,
  additionalParticipantSlot,
}: Props) {
  const toggleParticipant = (participantId: string) => {
    const isSelected = selectedParticipants.includes(participantId);
    if (isSelected) {
      // Remove participant from selection
      onParticipantsChange(selectedParticipants.filter((id) => id !== participantId));
    } else {
      // Add participant to selection
      onParticipantsChange([...selectedParticipants, participantId]);
    }
  };

  const selectedParticipantsArr = selectedParticipants
    .map((id) => participants.find((p) => p.id === id))
    .filter((p): p is BookingParticipant => !!p);
  const unselectedParticipantsArr = participants.filter(
    (p) => !selectedParticipants.includes(p.id)
  );

  return (
    <section className="mt-2">
      <h2 className="text-lg font-bold">
        <Trans>select-room-guest</Trans>
      </h2>

      <div className="overflow-x-auto whitespace-nowrap">
        {unselectedParticipantsArr.map((participant) => {
          return (
            <div key={participant.id} className="inline-block">
              {renderGuestChip({
                participant,
                onClick: () => toggleParticipant(participant.id),
              })}
            </div>
          );
        })}
      </div>
      {additionalParticipantSlot && <div className={'pt-4 pb-1'}>{additionalParticipantSlot}</div>}
      <div className={'w-[80%] mx-auto border-b border-b-gray-300 mb-5'} />
      <h2 className="text-sm font-bold">
        <Trans>chosen-guests</Trans>
      </h2>
      {selectedParticipantsArr.length > 0 && (
        <div>
          <div className="overflow-x-auto whitespace-nowrap">
            {selectedParticipantsArr.map((participant) => (
              <div key={participant.id} className="inline-block">
                {renderGuestChip({
                  participant,
                  isSelected: true,
                  onClick: () => toggleParticipant(participant.id),
                })}
              </div>
            ))}
          </div>
        </div>
      )}
      <span className="text text-sm opacity-20">
        {selectedParticipantsArr.length} <Trans>selected</Trans>
      </span>
    </section>
  );
}
